import { render, staticRenderFns } from "./enterMiniProgram.vue?vue&type=template&id=40181bfe&scoped=true"
import script from "./enterMiniProgram.vue?vue&type=script&lang=js"
export * from "./enterMiniProgram.vue?vue&type=script&lang=js"
import style0 from "./enterMiniProgram.vue?vue&type=style&index=0&id=40181bfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40181bfe",
  null
  
)

export default component.exports